import AbstractService from '~/composables/analytics/services/AbstractService'
import type ProductViewData from '~/types/analytics/marketplace/ProductViewData'
import pushToKlaviyoQueue from '~/utils/thirdPartyTrackers/Klaviyo/pushToKlaviyoQueue'
import type ProductAddedToCartData from '~/types/analytics/marketplace/ProductAddedToCartData'
import type { CartItem } from '~/types/analytics/marketplace/ProductAddedToCartData'
import type BeginCheckoutData from '~/types/analytics/marketplace/BeginCheckoutData'

export default class extends AbstractService {
  trackMarketplaceProductView(data: ProductViewData) {
    pushToKlaviyoQueue([
      'track',
      'Viewed Product',
      {
        ProductName: data.name,
        ProductID: data.sku,
        Categories: [data.category],
        ImageUrl: data.image,
        Url: window.location.href,
        Brand: data.manufacturer,
        Price: data.price,
      },
    ])
    pushToKlaviyoQueue([
      'trackViewedItem',
      {
        Title: data.name,
        ItemId: data.id,
        Categories: [data.category],
        ImageUrl: data.image,
        Url: window.location.href,
        Metadata: {
          Brand: data.manufacturer,
          Price: data.price,
        },
      },
    ])
  }

  trackMarketplaceProductAddedToCart(data: ProductAddedToCartData) {
    pushToKlaviyoQueue([
      'track',
      'Added to Cart',
      {
        $value: data.price,
        AddedItem_ProductName: data.name,
        AddedItem_ProductID: data.sku,
        AddedItem_SKU: data.sku,
        AddedItem_Categories: [data.category],
        AddedItem_ImageURL: data.image,
        AddedItem_URL: window.location.href,
        AddedItem_Price: data.price,
        AddedItem_Quantity: data.quantity,
        ItemNames: data.items.map((predicate) => predicate.name),
        CheckoutURL: data.checkoutUrl,
        Items: data.items.map((cartItem: CartItem) => {
          return {
            ProductID: cartItem.id,
            SKU: cartItem.sku,
            ProductName: cartItem.name,
            Quantity: cartItem.quantity,
            ItemPrice: cartItem.price,
            RowTotal: cartItem.price * cartItem.quantity,
            ProductURL: cartItem.url,
            ImageUrl: cartItem.image,
            ProductCategories: cartItem.categories,
          }
        }),
      },
    ])
  }

  trackBeginCheckout(data: BeginCheckoutData) {
    pushToKlaviyoQueue([
      'track',
      'Started Checkout',
      {
        $value: data.items
          .map((predicate) => predicate.price * predicate.quantity)
          .reduce((previousValue, currentValue) => previousValue + currentValue, 0),
        ItemNames: data.items.map((predicate) => predicate.name),
        Categories: data.items.map((predicate) => predicate.category),
        CheckoutURL: window.location.href,
        Items: data.items.map((predicate) => {
          return {
            ProductID: predicate.sku,
            ProductName: predicate.name,
            SKU: predicate.sku,
            ImageUrl: predicate.image,
            ProductURL: predicate.url,
            ItemPrice: predicate.price,
            Quantity: predicate.quantity,
            RowTotal: predicate.price * predicate.quantity,
            category: [predicate.category],
          }
        }),
      },
    ])
  }
}
